import { render, staticRenderFns } from "./SingleLengthResultsTableController.vue?vue&type=template&id=58dfdc7f&scoped=true"
import script from "./SingleLengthResultsTableController.vue?vue&type=script&lang=js"
export * from "./SingleLengthResultsTableController.vue?vue&type=script&lang=js"
import style0 from "./SingleLengthResultsTableController.vue?vue&type=style&index=0&id=58dfdc7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dfdc7f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SortBySelector: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/TableController/components/SortBySelector.vue').default})
